/**
 * Accès à l'ancien stockage `localStorage` brut — migration temporaire vers Preferences.
 * Seul ce fichier (avec preferences.ts) touche le localStorage legacy. À supprimer une fois
 * tous les clients migrés.
 */
export const readLegacy = (key: string): string | null => localStorage.getItem(key);

export const clearLegacy = (key: string): void => localStorage.removeItem(key);
